/**
 * Formats a file size in bytes to a human-readable string
 *
 * @param bytes - Size in bytes
 * @param decimals - Number of decimal places to show
 * @returns Formatted size string (e.g., "1.5 MB")
 */
export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return Number.parseFloat((bytes / k ** i).toFixed(decimals)) + ' ' + sizes[i];
}
